// extracted by mini-css-extract-plugin
export default {"desktopLogo":"GlobalHeaderLogo-module__desktopLogo___QsxPP","mobileLogo":"GlobalHeaderLogo-module__mobileLogo___x-hb2"};